import { render, staticRenderFns } from "./RamoModal.vue?vue&type=template&id=10b15e10&scoped=true"
import script from "./RamoModal.vue?vue&type=script&lang=js"
export * from "./RamoModal.vue?vue&type=script&lang=js"
import style0 from "./RamoModal.vue?vue&type=style&index=0&id=10b15e10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b15e10",
  null
  
)

export default component.exports